import get from "lodash/get";

export const selectCurrentJourneyConfig = (state) => get(state, `journey.config.${get(state, 'journey.selectedJourney.hashId')}`)
